import { APP_NAME } from "@constants/app.constants";
import ProductsEditComponent from "@screens/products/products-edit/product-edit.component";
import ProductsListComponent from "@screens/products/products-list/product-list.component";
import ProductsCreateComponent from "@screens/products/products-create/product-create.component";

const productsRoutes = [
  {
    name: `Products - ${APP_NAME}`,
    path: "/products",
    icon: "layout",
    component: ProductsListComponent,
  },
  {
    name: `Create Products - ${APP_NAME}`,
    path: "/products/create",
    component: ProductsCreateComponent,
  },
  {
    name: `Edit Products - ${APP_NAME}`,
    path: "/products/edit",    
    component: ProductsEditComponent,
  },
];

export default productsRoutes;
